import { render, staticRenderFns } from "./MainModal.vue?vue&type=template&id=053d40fd&"
import script from "./MainModal.vue?vue&type=script&lang=js&"
export * from "./MainModal.vue?vue&type=script&lang=js&"
import style0 from "./MainModal.vue?vue&type=style&index=0&id=053d40fd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports